import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, parseISO } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Extract sequential number from quote reference like "ORC-2026/007" → "#7" */
export function fmtQuoteSeq(number: string | null | undefined): string {
  if (!number) return "#—";
  const match = number.match(/\/(\d+)$/);
  if (!match) return `#${number}`;
  return `#${parseInt(match[1], 10)}`;
}

/** Format quote for display: "ORC-2026/008 · João Silva · 150.00€" */
export function fmtQuoteDisplay(
  number: string | null | undefined,
  clientName: string | null | undefined,
  value?: number | string | null,
): string {
  const ref = number || "—";
  const parts = [ref];
  if (clientName) parts.push(clientName);
  if (value !== null && value !== undefined && value !== "") {
    parts.push(fmtValue(value));
  }
  return parts.join(" · ");
}

/** Format an ISO date string (yyyy-MM-dd) or Date to dd/MM/yyyy */
export function fmtDate(d: string | Date): string {
  if (!d) return "—";
  const date = typeof d === "string" ? parseISO(d) : d;
  return format(date, "dd/MM/yyyy");
}

/** Format an ISO datetime string or Date to dd/MM/yyyy HH:mm */
export function fmtDateTime(d: string | Date): string {
  if (!d) return "—";
  const date = typeof d === "string" ? parseISO(d) : d;
  return format(date, "dd/MM/yyyy HH:mm");
}

/** Global currency decimal places setting (default 2) */
let _currencyDecimals = 2;

export function setCurrencyDecimals(d: number) {
  _currencyDecimals = d;
}

export function getCurrencyDecimals(): number {
  return _currencyDecimals;
}

/** Format a numeric value with configured decimal places and € suffix */
export function fmtValue(v: number | string | null | undefined): string {
  const d = _currencyDecimals;
  const zero = (0).toFixed(d) + "€";
  if (v === null || v === undefined || v === "") return zero;
  const n = typeof v === "string" ? parseFloat(v) : v;
  if (isNaN(n)) return zero;
  return `${n.toFixed(d)}€`;
}
